import { render, staticRenderFns } from "./AssociaUtentiPresidiModalComponent.vue?vue&type=template&id=70f7e3ae"
import script from "./AssociaUtentiPresidiModalComponent.vue?vue&type=script&lang=js"
export * from "./AssociaUtentiPresidiModalComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports